import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { Student } from './Student.js';

@Entity()
export class HefteStudent extends Student {
  public static override _class = 'HefteStudent';
  public static override readableName = 'Hefte-Schüler:in';

  @Field(() => String)
  public plainTextPassword: Maybe<string>;
}
